import { render, staticRenderFns } from "./OrderGiftMessage.vue?vue&type=template&id=03361b4e&"
import script from "./OrderGiftMessage.vue?vue&type=script&lang=js&"
export * from "./OrderGiftMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports